import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseProductCategory } from "./UseProductCategory";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditProductCategory(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getCategoryByID, validate, updateCategory } = UseProductCategory();
  const [state, setState] = useState({
    id: "",
    faName: "",
    enName: "",
    description: "",
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state.id) {
      getCategoryByID(location.state.id, (categoryRes) => {
        setState({
          id: categoryRes.id,
          faName: categoryRes.faName,
          enName: categoryRes.enName,
          description: categoryRes.description ? categoryRes.description : "",
        });
      });
    }
  }, []);

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/categories" },
          { name: "ویرایش دسته محصولات", url: "/categories/editcategory" },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.id ? state.id : ""}
              error={errorState.id}
              sx={{ width: "100%" }}
              label=" ID"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, id: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: "100%" }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                width: "100%",
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn="span 12">
            {state.id != "" && (
              <CKEditor
                config={{
                  language: "fa",
                  link: {
                    decorators: {
                      addTargetToExternalLinks: {
                        mode: "automatic",
                        callback: (url) => /^(https?:)?\/\//.test(url),
                        attributes: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        },
                      },
                    },
                  },
                }}
                editor={Editor}
                style={{ p: "100px", width: "100%" }}
                data={state.description ? state.description : ""}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  if (state.id) {
                    setState({ ...state, description: data });
                  }
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle(
                      "height",
                      "500px",
                      editor.editing.view.document.getRoot()
                    );
                  });
                }}
              />
            )}
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateCategory(state, () => {
                    navigate("/categories", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/categories", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditProductCategory;
